import { Icon } from "@iconify/react/dist/iconify.js"
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    Typography,
} from "@mui/material"
import { makeStyles } from "@mui/styles"
import { useEffect, useState } from "react"

const useStyles = makeStyles({
    card: {
        maxWidth: 300,
        padding: "12px 8px",
        marginLeft: "auto",
        marginRight: "auto",
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
})

function UserSubscription({ subscription, setContactModalOpen, handleCancel }) {
    const classes = useStyles()
    const [plan, setPlan] = useState({})

    useEffect(() => {
        if (subscription?.plan) {
            setPlan({
                title: subscription.plan.name,
                planId: subscription.plan.id,
                price: subscription.plan.value,
                interval: subscription.plan.interval,
                users: subscription.plan.users,
                connections: subscription.plan.connections,
                queues: subscription.plan.queues,
                buttonText: "SELECIONAR",
                buttonVariant: "outlined",
                features: [
                    {
                        name: "Dashboard",
                        isEnabled: subscription.plan.dashboard,
                    },
                    { name: "Kanban", isEnabled: subscription.plan.kanban },
                    { name: "Tags", isEnabled: subscription.plan.tags },
                    {
                        name: "Chat interno",
                        isEnabled: subscription.plan.chats,
                    },
                    {
                        name: "Áudios pré-gravados",
                        isEnabled: subscription.plan.audios,
                    },
                    {
                        name: "Respostas Rápidas",
                        isEnabled: subscription.plan["quick-messages"],
                    },
                    {
                        name: "Mensagens programadas",
                        isEnabled: subscription.plan.schedules,
                    },
                    { name: "Formulários", isEnabled: subscription.plan.forms },
                    {
                        name: "Cadastro de Produtos",
                        isEnabled: subscription.plan.products,
                    },
                    {
                        name: "Gerencimento de Leads",
                        isEnabled: subscription.plan.leads,
                    },
                    {
                        name: "Integrações",
                        isEnabled: subscription.plan.queueIntegration,
                    },
                    {
                        name: "Inteligência Artificial",
                        isEnabled: subscription.plan.prompt,
                    },
                    {
                        name: "Automações via Instagram",
                        isEnabled: subscription.plan.automation,
                    },
                ],
            })
        }
    }, [subscription?.plan])

    return (
        <div>
            {!!subscription && (
                <Card className={classes.card} variant="outlined">
                    <CardContent>
                        <Typography
                            className={classes.title}
                            color="textSecondary"
                            gutterBottom
                            align="center"
                        >
                            {subscription.status === "waitingPayment"
                                ? "Pagamento pendente"
                                : subscription.status === "waitingPayment"
                                  ? "Aguardando pagamento"
                                  : "Sua assinatura"}
                        </Typography>
                        <Typography variant="h5" component="h2" align="center">
                            {subscription.plan.name}
                        </Typography>

                        <Box display="flex" alignItems="center" gap={1} mt={2}>
                            <Icon icon="healthicons:call-centre-outline" />
                            <Typography variant="body1">
                                {plan.users} atendente
                                {plan.users !== 1 && "s"}
                            </Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <Icon icon="heroicons:queue-list-solid" />
                            <Typography variant="body1">
                                {plan.queues} filas
                            </Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <Icon icon="material-symbols:wifi" />
                            <Typography variant="body1">
                                {plan.connections} conexões
                            </Typography>
                        </Box>
                        {plan?.features?.map(({ name, isEnabled }) => {
                            return (
                                <Typography key={name}>
                                    {`${isEnabled ? "✔️" : "❌"} ${name}`}
                                </Typography>
                            )
                        })}

                        <Typography
                            variant="h5"
                            component="h2"
                            align="center"
                            style={{ marginTop: "1rem" }}
                        >
                            R$ {subscription.plan.value}
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                width: "100%",
                            }}
                        >
                            {subscription.status === "waitingPayment" &&
                                !!subscription.providerSubscriptionId && (
                                    <Button
                                        size="medium"
                                        variant="contained"
                                        fullWidth
                                        color="primary"
                                        href={subscription.paymentUrl}
                                        target="_blank"
                                    >
                                        Pagar e ativar assinatura
                                    </Button>
                                )}

                            <Button
                                size="medium"
                                variant="contained"
                                fullWidth
                                color="secondary"
                                onClick={handleCancel}
                                target="_blank"
                            >
                                Cancelar assinatura
                            </Button>
                        </div>
                    </CardActions>
                </Card>
            )}
            {!subscription && (
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    gap={2}
                    justifyContent={"center"}
                >
                    <Typography
                        variant="h5"
                        component="h2"
                        align="center"
                        style={{ marginBottom: "1rem" }}
                    >
                        Assine um plano para continuar
                    </Typography>

                    <Typography
                        className={classes.pos}
                        color="textSecondary"
                        align="center"
                    >
                        O pagamento é feito via cartão de crédito com total
                        segurança e pode levar alguns dias para ser liberado
                        dependendo da administradora do seu cartão.
                    </Typography>

                    <Button
                        size="large"
                        variant="contained"
                        color="primary"
                        onClick={() => setContactModalOpen(true)}
                    >
                        Ver planos
                    </Button>
                </Box>
            )}
        </div>
    )
}

export default UserSubscription
